import React    from 'react';
import ReactDOM from 'react-dom';
import App      from './app';
import actions  from './actions';
import               './styles.scss';

let appId = 'email-modal';
let appElement  = document.getElementById(appId);
let senderName = window.medscape.user.name;
let senderEmail = window.medscape.user.email;

if(appElement==null) {
  appElement = document.createElement("div");
  let bodyEl = document.getElementsByTagName("BODY")[0];
  appElement.setAttribute("id", appId);
  bodyEl.appendChild(appElement);
}
let props = {
  senderName: senderName,
  senderEmail: senderEmail
}
let modal = React.createElement(App,props);
ReactDOM.render(modal,appElement);
export default actions;



// WEBPACK FOOTER //
// ./medscape_modules/email-modal/index.js